import { Outlet } from 'react-router-dom';

import useSocket from '@/hooks/domain/App/useSocket';
import useAuth from '@/hooks/domain/useAuth';
import LoadingLayout from '@/layouts/LoadingLayout';
import useCommonStore from '@/stores/pure/CommonStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';

const WorkspaceLayout = () => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const { appInit, appLoadingState } = useCommonStore((state) => ({
    appInit: state.appInit,
    appLoadingState: state.appLoadingState,
  }));

  useAuth();
  useSocket();

  if (appLoadingState) return <LoadingLayout />;
  if (!appInit) return <LoadingLayout />;
  if (!currWorkspace) return <LoadingLayout />;

  return <Outlet />;
};

export default WorkspaceLayout;
